$(document).ready(function(){
  
  var bsubPrice = setInterval(function(){
    var price = $("[data-bsub-per-delivery-price]").text();
    if( price.length ){
      $(".additional-bsub-widget__group .delivery-price").text(price);
      $(".additional-bsub-widget__group").show();
      clearInterval(bsubPrice);
    }
  }, 1000);

  // random stock
  const currentDate = new Date().toISOString().split('T')[0];
  if( window.location.pathname.indexOf("/products/") > -1){
    // Generate a random number based on the current date
    const randomStock = generateRandomNumber(currentDate);
    //console.log(`stock: ${randomStock}`);
    
    $(".inventory__title .stock span").text(randomStock);
    $(".inventory__title").show();
  }
  
  function generateRandomNumber(dateString) {
    const min = 11;
    const max = 20;

    // Convert the date string to a numerical value
    const dateValue = Date.parse(dateString);

    // Seed the random number generator with the date value
    const seed = dateValue % (2**31 - 1);
    const randomSeed = (seed * 9301 + 49297) % 233280;
    const normalizedSeed = randomSeed / 233280;

    // Map the normalized seed to the desired range
    var randomNumber = Math.floor(min + normalizedSeed * (max - min + 1));
    console.log(randomNumber);
    
    var prodID = parseInt( $('.product-form input[name="id"]').val() );
    randomNumber = prodID%randomNumber;

    if( randomNumber < 3 )
      randomNumber = 3;

    // do{
    //   var sum = 0;
    //   while (randomNumber) {
    //     sum += randomNumber % 10;
    //     randomNumber = Math.floor(randomNumber / 10);
    //   }
    //   randomNumber = sum;
    // }
    // while (randomNumber > 20 );
    
    return randomNumber;
  }
  
})

